import { setLeftSideDrawerState } from '../leftSideDrawer/actions';
import { closeSideBar } from '../selectedNode/actions';
import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { DRAWER_MODES } from '@/store/modules/leftSideDrawer/state';
import { SET_CONFIGURATIONS_VALUES } from './mutations';
import state from './state';
const buildConfigurationEditorActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);
// actions declarations
export const enterConfigurationEdit = buildConfigurationEditorActionObject('enterConfigurationEdit');
export const setConfigurationValues = buildConfigurationEditorActionObject('setConfigurationValues');
export const setConfigurationsValues = buildConfigurationEditorActionObject('setConfigurationsValues');
export const setMappingConfigurationFieldValues = buildConfigurationEditorActionObject('setMappingConfigurationFieldValues');

const actions = {
	...StoreModuleService.createDefaultActions(),
	[enterConfigurationEdit.action]({ dispatch, commit }) {
		dispatch(setLeftSideDrawerState.fullPath, DRAWER_MODES.test, { root: true });
		dispatch(closeSideBar.fullPath, {}, { root: true });
		commit(SET_CONFIGURATIONS_VALUES, {});
	},
	[setConfigurationsValues.action]({ commit }, configurationsValues) {
		commit(SET_CONFIGURATIONS_VALUES, configurationsValues);
	},
	[setConfigurationValues.action]({ dispatch }, configurationValues) {
		const newConfigurationsValues = { ...state.configurationsValues, ...configurationValues };
		dispatch(setConfigurationsValues.action, newConfigurationsValues);
	},
	async [setMappingConfigurationFieldValues.action]({ dispatch }, payload) {
		const { interfaceUUID, fieldUUID, fieldValue } = payload;
		const newConfigurationsValues = { ...state.configurationsValues };
		for (const configurationId of Object.keys(newConfigurationsValues)) {
			if (newConfigurationsValues[configurationId]?.[interfaceUUID]) {
				//found published configuration
				const newValue = { ...(newConfigurationsValues[configurationId][interfaceUUID][fieldUUID] || {}), ...fieldValue };
				newConfigurationsValues[configurationId][interfaceUUID][fieldUUID] = newValue;
				await dispatch(setConfigurationsValues.action, newConfigurationsValues);
			}
		}
	},
};

export default actions;
